/**
 * Environment configuration utility
 * Centralized management of environment variables with fallbacks
 */

const config = {
  // API Configuration
  API_BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000',
  
  // Environment
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || 'development',
  DEBUG: process.env.REACT_APP_DEBUG === 'true',
  
  // Feature flags
  ENABLE_ANALYTICS: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
  ENABLE_DEBUG_TOOLS: process.env.REACT_APP_ENABLE_DEBUG_TOOLS === 'true',
  
  // Default values
  DEFAULT_IMAGE: '/default-image.jpg',
  DEFAULT_LOGO: '/logo.svg',
  DEFAULT_HERO: '/default-hero.jpg',
  
  // Cache settings
  CACHE_DURATION: 5 * 60 * 1000, // 5 minutes
  MAX_CACHE_SIZE: 50,
  
  // Performance
  DEBOUNCE_DELAY: 300,
  THROTTLE_DELAY: 100,
  
  // Pagination
  DEFAULT_PAGE_SIZE: 10,
  MAX_PAGE_SIZE: 100,
};

// Validation
if (!config.API_BASE_URL) {
  console.warn('REACT_APP_API_URL is not set. Using default:', config.API_BASE_URL);
}

// Helper functions
export const isDevelopment = () => config.ENVIRONMENT === 'development';
export const isProduction = () => config.ENVIRONMENT === 'production';
export const isDebug = () => config.DEBUG;

// URL helpers
export const getApiUrl = (endpoint = '') => {
  const base = config.API_BASE_URL.replace(/\/$/, '');
  const path = endpoint.replace(/^\//, '');
  return `${base}/${path}`;
};

export const getBackendUrl = (path = '') => {
  const base = config.BACKEND_URL.replace(/\/$/, '');
  const cleanPath = path.replace(/^\//, '');
  return `${base}/${cleanPath}`;
};

// Add this to your api.js if not already there

export const getMediaUrl = (path) => {
  if (!path) return null;
  
  // If already a full URL, return as is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  
  // If starts with /media/, prepend backend URL
  if (path.startsWith('/media/')) {
    return `${config.BACKEND_URL}${path}`;
  }
  
  // If just a filename, assume it's in media root
  if (path && !path.startsWith('/')) {
    return `${config.BACKEND_URL}/media/${path}`;
  }
  
  // Default fallback
  return path;
};

// Logging utility
export const log = {
  info: (...args) => {
    if (isDevelopment() || isDebug()) {
      console.log('[INFO]', ...args);
    }
  },
  warn: (...args) => {
    console.warn('[WARN]', ...args);
  },
  error: (...args) => {
    console.error('[ERROR]', ...args);
  },
  debug: (...args) => {
    if (isDebug()) {
      console.debug('[DEBUG]', ...args);
    }
  }
};

export default config;